export default __webpack_public_path__ + "static/media/mo.d04cfd5d.svg";